import { render, staticRenderFns } from "./SelectMenuCustom.vue?vue&type=template&id=441a5434&"
import script from "./SelectMenuCustom.vue?vue&type=script&lang=js&"
export * from "./SelectMenuCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports